<card name="User projects table">
  <div card content>
    <smart-table [headers]="headers" [source]="source">
      <ng-template smartTableColumn="name" let-item>
        <td>
          {{ item.name }} <br>
          <small class="text-muted">{{ item.devMode }}</small>
        </td>
      </ng-template>

      <ng-template smartTableColumn="createdAt" let-item>
        <td>
          {{ item.createdAt | moment }}
        </td>
      </ng-template>

      <ng-template smartTableColumn="active" let-item>
        <td>
          <badge-exist existText="Active" [item]="item.active"></badge-exist>
        </td>
      </ng-template>

      <ng-template smartTableColumn="product" let-item>
        <td>
          <a routerLink="/">{{ item.productName }}</a> <br>
          <small class="text-muted">{{ item.subject }}, {{ item.type }}</small>
        </td>
      </ng-template>
    </smart-table>
  </div>
</card>
